/**
 * Job-status predicates (T027, C2). Pure — drive polling (refetchInterval) and
 * are unit-tested table-wise (T029). Mirror `JobStatus::is_terminal`.
 */
import { TERMINAL_STATUSES, type Job, type JobsResponse } from './schemas'

const TERMINAL: ReadonlySet<string> = new Set(TERMINAL_STATUSES)

/** Terminal = polling must stop (FR-009). */
export function isTerminal(status: string): boolean {
  return TERMINAL.has(status)
}

/**
 * Active = should keep polling. `undefined` (no data yet) returns `true` so the
 * first fetch happens — the real status arrives and stops it (C2).
 */
export function isActive(job: Job | undefined): boolean {
  if (!job) return true
  return !isTerminal(job.status)
}

/** Any active job in the list → keep refreshing the list. `undefined` → true. */
export function hasActiveJob(list: JobsResponse | undefined): boolean {
  if (!list) return true
  return list.jobs.some((job) => isActive(job))
}
